import { Link, useLocation } from 'react-router-dom';

export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  if (pathname === '/contact') return null;
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-charcoal-line bg-charcoal-deep/95 px-4 py-3 backdrop-blur-lg lg:hidden"
      data-testid="sticky-mobile-cta"
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
    >
      <div className="flex gap-3">
        <Link
          to="/pricing"
          data-testid="sticky-cta-pricing"
          className="flex flex-1 items-center justify-center rounded-full border border-offwhite/25 py-3 font-heading text-sm font-bold text-offwhite"
        >
          See Packages
        </Link>
        <Link
          to="/contact"
          data-testid="sticky-cta-quote"
          className="flex flex-1 items-center justify-center rounded-full bg-lime py-3 font-heading text-sm font-bold text-charcoal"
        >
          Get a Free Quote
        </Link>
      </div>
    </div>
  );
}
